// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3ghca","dragIcon":"Choice_dragIcon__l5vnE","left":"Choice_left__1UonE","input":"Choice_input__3BUm9"};